import {
    ACCEPT_CUSTOMER_INVITE_FAIL,
    ACCEPT_CUSTOMER_INVITE_REQUEST,
    ACCEPT_CUSTOMER_INVITE_SUCCESS,
    ACCEPT_HEAD_NURSE_INVITE_FAIL,
    ACCEPT_HEAD_NURSE_INVITE_REQUEST,
    ACCEPT_HEAD_NURSE_INVITE_SUCCESS,
    AcceptCustomerInviteRequest,
    AcceptHeadNurseInviteRequest,
    ADD_NURSE_BY_HN_FAIL,
    ADD_NURSE_BY_HN_REQUEST,
    ADD_NURSE_BY_HN_SUCCESS,
    AddNurseByHNRequest,
    CLEAR_HEAD_NURSE_MESSAGE,
    CLEAR_INVITED_CUSTOMER_DATA,
    CustomerInvite,
    DELETE_CUSTOMER_FAIL,
    DELETE_CUSTOMER_REQUEST,
    DELETE_CUSTOMER_SUCCESS,
    EDIT_HEAD_NURSE_PROFILE_FAIL,
    EDIT_HEAD_NURSE_PROFILE_REQUEST,
    EDIT_HEAD_NURSE_PROFILE_SUCCESS,
    EDIT_SENIOR_BY_HN_FAIL,
    EDIT_SENIOR_BY_HN_REQUEST,
    EDIT_SENIOR_BY_HN_SUCCESS,
    EditHeadNurseProfileRequest,
    EditSeniorByHNRequest,
    GET_NURSE_BY_HN_ID_FAIL,
    GET_NURSE_BY_HN_ID_REQUEST,
    GET_NURSE_BY_HN_ID_SUCCESS,
    GET_NURSES_BY_HN_FAIL,
    GET_NURSES_BY_HN_REQUEST,
    GET_NURSES_BY_HN_SUCCESS,
    GET_SENIORS_BY_HN_FAIL,
    GET_SENIORS_BY_HN_REQUEST,
    GET_SENIORS_BY_HN_SUCCESS,
    HeadNurseInvite,
    INVITE_CUSTOMER_FAIL,
    INVITE_CUSTOMER_REQUEST,
    INVITE_CUSTOMER_SUCCESS,
    INVITE_HEAD_NURSE_FAIL,
    INVITE_HEAD_NURSE_REQUEST,
    INVITE_HEAD_NURSE_SUCCESS,
    INVITED_CUSTOMER_DATA_FAIL,
    INVITED_CUSTOMER_DATA_REQUEST,
    INVITED_CUSTOMER_DATA_SUCCESS,
} from "../types";
export const inviteHeadNurseRequest = (headNurseInvite: HeadNurseInvite, history: any) => {
    return {
        type: INVITE_HEAD_NURSE_REQUEST,
        payload: { headNurseInvite, history },
    };
};

export const inviteHeadNurseSuccess = () => {
    return {
        type: INVITE_HEAD_NURSE_SUCCESS,
    };
};

export const inviteHeadNurseFail = (error: any) => {
    return {
        type: INVITE_HEAD_NURSE_FAIL,
        payload: {
            error,
        },
    };
};

export const addNurseByHNRequest = (nurseData: AddNurseByHNRequest, history: any) => {
    return {
        type: ADD_NURSE_BY_HN_REQUEST,
        payload: { nurseData, history },
    };
};

export const addNurseByHNSuccess = () => {
    return {
        type: ADD_NURSE_BY_HN_SUCCESS,
    };
};

export const addNurseByHNFail = (error: any) => {
    return {
        type: ADD_NURSE_BY_HN_FAIL,
        payload: {
            error,
        },
    };
};

export const acceptHeadNurseInviteRequest = (inviteData: AcceptHeadNurseInviteRequest) => {
    return {
        type: ACCEPT_HEAD_NURSE_INVITE_REQUEST,
        payload: inviteData,
    };
};

export const acceptHeadNurseInviteSuccess = () => {
    return {
        type: ACCEPT_HEAD_NURSE_INVITE_SUCCESS,
    };
};

export const acceptHeadNurseInviteFail = (error: any) => {
    return {
        type: ACCEPT_HEAD_NURSE_INVITE_FAIL,
        payload: {
            error,
        },
    };
};

export const getNursesByHNRequest = () => {
    return {
        type: GET_NURSES_BY_HN_REQUEST,
    };
};

export const getNursesByHNSuccess = (nurses: any[]) => {
    return {
        type: GET_NURSES_BY_HN_SUCCESS,
        payload: nurses,
    };
};

export const getNursesByHNFail = (error: any) => {
    return {
        type: GET_NURSES_BY_HN_FAIL,
        payload: {
            error,
        },
    };
};

// Customer invite action creators
export const inviteCustomerRequest = (customerData: CustomerInvite, history: any) => {
    return {
        type: INVITE_CUSTOMER_REQUEST,
        payload: { customerInvite: customerData, history },
    };
};

export const inviteCustomerSuccess = () => {
    return {
        type: INVITE_CUSTOMER_SUCCESS,
    };
};

export const inviteCustomerFail = (error: any) => {
    return {
        type: INVITE_CUSTOMER_FAIL,
        payload: {
            error,
        },
    };
};

// Get specific nurse by ID action creators
export const getNurseByHNIdRequest = (id: number) => {
    return {
        type: GET_NURSE_BY_HN_ID_REQUEST,
        payload: { id },
    };
};

export const getNurseByHNIdSuccess = (nurse: any) => {
    return {
        type: GET_NURSE_BY_HN_ID_SUCCESS,
        payload: nurse,
    };
};

export const getNurseByHNIdFail = (error: any) => {
    return {
        type: GET_NURSE_BY_HN_ID_FAIL,
        payload: {
            error,
        },
    };
};

// Get seniors list by head nurse action creators
export const getSeniorsByHNRequest = () => {
    return {
        type: GET_SENIORS_BY_HN_REQUEST,
    };
};

export const getSeniorsByHNSuccess = (seniors: any[]) => {
    return {
        type: GET_SENIORS_BY_HN_SUCCESS,
        payload: seniors,
    };
};

export const getSeniorsByHNFail = (error: any) => {
    return {
        type: GET_SENIORS_BY_HN_FAIL,
        payload: {
            error,
        },
    };
};

// Edit senior by head nurse
export const editSeniorByHNRequest = (seniorData: EditSeniorByHNRequest) => {
    return {
        type: EDIT_SENIOR_BY_HN_REQUEST,
        payload: seniorData,
    };
};

export const editSeniorByHNSuccess = (senior?: any) => {
    return {
        type: EDIT_SENIOR_BY_HN_SUCCESS,
        payload: senior,
    };
};

export const editSeniorByHNFail = (error: any) => {
    return {
        type: EDIT_SENIOR_BY_HN_FAIL,
        payload: {
            error,
        },
    };
};

// Customer invite acceptance action creators (for accepting invitations)
export const acceptCustomerInviteRequest = (inviteData: AcceptCustomerInviteRequest) => {
    return {
        type: ACCEPT_CUSTOMER_INVITE_REQUEST,
        payload: inviteData,
    };
};

export const acceptCustomerInviteSuccess = () => {
    return {
        type: ACCEPT_CUSTOMER_INVITE_SUCCESS,
    };
};

export const acceptCustomerInviteFail = (error: any) => {
    return {
        type: ACCEPT_CUSTOMER_INVITE_FAIL,
        payload: {
            error,
        },
    };
};

// Delete customer action creators
export const deleteCustomerRequest = (customerId: number) => {
    return {
        type: DELETE_CUSTOMER_REQUEST,
        payload: { customerId },
    };
};

export const deleteCustomerSuccess = () => {
    return {
        type: DELETE_CUSTOMER_SUCCESS,
    };
};

export const deleteCustomerFail = (error: any) => {
    return {
        type: DELETE_CUSTOMER_FAIL,
        payload: {
            error,
        },
    };
};

export const editHeadNurseProfileRequest = (data: EditHeadNurseProfileRequest, history: any) => {
    return {
        type: EDIT_HEAD_NURSE_PROFILE_REQUEST,
        payload: { data, history },
    };
};

export const editHeadNurseProfileSuccess = (profile?: any) => {
    return {
        type: EDIT_HEAD_NURSE_PROFILE_SUCCESS,
        payload: profile,
    };
};

export const editHeadNurseProfileFail = (error: string) => {
    return {
        type: EDIT_HEAD_NURSE_PROFILE_FAIL,
        payload: error,
    };
};

export const clearHeadNurseMessage = () => {
    return {
        type: CLEAR_HEAD_NURSE_MESSAGE,
    };
};

export const invitedCustomerDataRequest = (data: any) => {
    return {
        type: INVITED_CUSTOMER_DATA_REQUEST,
        payload: data,
    };
};

export const invitedCustomerDataSuccess = (data: any) => {
    return {
        type: INVITED_CUSTOMER_DATA_SUCCESS,
        payload: data,
    };
};
export const invitedCustomerDataFail = (error: any) => {
    return {
        type: INVITED_CUSTOMER_DATA_FAIL,
        payload: {
            error,
        },
    };
};

export const invitedCustomerDataClear = () => {
    return {
        type: CLEAR_INVITED_CUSTOMER_DATA,
    };
};
